const getUniqueElementsByProp = ({ elements, prop }: { elements: Record<string, any>[]; prop: string }) => [...new Set(elements?.map(a => a[prop]))];

export default getUniqueElementsByProp;
